import { render, staticRenderFns } from "./FooterH5.vue?vue&type=template&id=311c086b&scoped=true&"
import script from "./FooterH5.vue?vue&type=script&lang=js&"
export * from "./FooterH5.vue?vue&type=script&lang=js&"
import style0 from "./FooterH5.vue?vue&type=style&index=0&id=311c086b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311c086b",
  null
  
)

export default component.exports